import type { SVGProps } from "react";
export interface FlowerTulipIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FlowerTulipIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FlowerTulipIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.875 12a1.125 1.125 0 1 1 2.25 0v4.021a6.7 6.7 0 0 1 1.368-1.327c1.937-1.391 4.498-1.592 7.692-1.056.542.09.94.56.94 1.109 0 3.237-1.044 5.673-3.19 7.076-2.034 1.33-4.807 1.555-7.936 1.054-3.128.5-5.9.277-7.934-1.054C1.92 20.42.875 17.985.875 14.747c0-.55.397-1.018.939-1.11 3.195-.535 5.755-.334 7.692 1.057a6.7 6.7 0 0 1 1.37 1.327v-4.02Zm-2.682 4.52c-1.068-.766-2.614-1.088-5.03-.804.181 2.167.986 3.475 2.133 4.225 1.187.776 2.952 1.097 5.322.851-.59-2.198-1.38-3.521-2.425-4.271Zm12.642-.804c-2.415-.284-3.961.038-5.029.805-1.045.75-1.837 2.073-2.426 4.271 2.37.246 4.136-.075 5.323-.851 1.147-.75 1.95-2.058 2.132-4.225"
      />
      <path
        fill={color}
        d="m16.375 3.822-.947.63a1.63 1.63 0 0 1-1.699.065l-.217-.146L12 3.159l-1.51 1.212a1.63 1.63 0 0 1-1.69.21l-.228-.128-.946-.631v2.677a4.375 4.375 0 1 0 8.75 0V3.822Zm2.25 2.677a6.625 6.625 0 1 1-13.25 0V2.654c0-1.217 1.272-1.973 2.32-1.47l.207.118 1.536 1.025 1.234-.985.15-.11a2.13 2.13 0 0 1 2.356 0l.15.11 1.232.985 1.54-1.025.206-.117c1.048-.503 2.318.253 2.319 1.469z"
      />
    </svg>
  );
}
